// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCt8z-VjnJb4vxRHDbnAoIPGobBPivhA6w",
  authDomain: "baseball-neverwin.firebaseapp.com",
  projectId: "baseball-neverwin",
  storageBucket: "baseball-neverwin.firebasestorage.app",
  messagingSenderId: "705389931218",
  appId: "1:705389931218:web:b14653a2d393cbfb7adb0b",
  measurementId: "G-R7784XS9LD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };